"use client";
import { motion } from "framer-motion";
interface ServiceTitleProps {
  badgeText: string;
  title: string;
  description: string;
}

export default function ServiceTitle({
  badgeText,
  title,
  description,
}: ServiceTitleProps) {
  return (
    // <motion.div
    //   initial={{ opacity: 0, y: 20 }}
    //   whileInView={{ opacity: 1, y: 0 }}
    //   viewport={{ once: true, amount: 0.3 }}
    //   transition={{ duration: 0.6 }}
    // >
    <div>
      <div className="flex flex-col justify-center items-center text-center">
        <span
          className="text-base leading-6 sm:text-xl sm:leading-7 md:text-2xl md:leading-8 bg-black-100 text-white px-4 py-1 rounded-full !tracking-tighter"
          style={{ fontFamily: '"pre-Medium", sans-serif' }}
        >
          {badgeText}
        </span>

        <p
          className="text-4xl md:text-5xl xl:text-7xl leading-20 md:leading-24 mt-5 tracking-tight md:mt-10 xl:mt-20 text-black-100"
          style={{ fontFamily: '"aggro-bold", sans-serif' }}
        >
          {title}
        </p>

        <p
          className="text-black-300  text-[15px] sm:text-xl sm:leading-8 md:text-2xl md:leading-10 tracking-tight mt-2 xl:mt-4 break-keep"
          style={{ fontFamily: '"pre-Medium", sans-serif' }}
        >
          {description.split("\n").map((line, idx) => (
            <span key={idx}>
              {line}
              <br />
            </span>
          ))}
        </p>
      </div>
    </div>
    // </motion.div>
  );
}
